(() => {
  'use strict';

  angular
    .module('uwAgenda.settings.aiagent')
    .directive('aiagentTranscriptionsTableRow', ['TranscriptionService', '$uibModal', AiAgentTranscriptionsTableRowFn]);

  function AiAgentTranscriptionsTableRowFn(TranscriptionService, $uibModal) {
    return {
      link: link,
      restrict: 'A',
      replace: true,
      templateUrl: '/app/settings/aiagent/templates/aiagent-transcriptions-table-row.template.html'
    };

    function link(scope, element, attrs) {
      scope.setAsRead = (t) => {
        return $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: '/app/settings/aiagent/templates/aiagent-transcriptions-content-modal.template.html',
          controller: 'TranscriptionContentModalController',
          controllerAs: 'vm',
          size: 'md',
          resolve: {
            transcription: () => t,
            hideMarkAsReadButton: () => false
          }
        }).result;
      }
    }
  }
})();